export default "__VITE_ASSET__830595f4__"